// extracted by mini-css-extract-plugin
export var md = "_58-4";
export var semantic = "_58-5";
export var sm = "_58-3";
export var text = "_58-6";
export var toggleInput = "_58-0";
export var toggleSwitch = "_58-1";
export var xs = "_58-2";